export default "__VITE_ASSET__l3FKJFxy__"